import { Box, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import ColorList from '../EditForm/common/ColorList';
import { dailyStatsRangeFields } from '../../../config/utils/dailyStatsColors';

function ColorField({ label, value, onChange }) {
  return (
    <Box>
      <Typography component="div" variant="body2">
        {label}
      </Typography>
      <ColorList label={label} value={value} onChange={onChange} customPicker />
    </Box>
  );
}

function ColorRangeRow({ item, onChange, errors, fromKey, toKey, colorKey, label }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flexWrap: 'wrap', mb: 2 }}>
      <Typography sx={{ pt: 1, minWidth: 70 }}>{label}</Typography>
      <TextField
        label="From (m)"
        type="number"
        size="small"
        value={item[fromKey] ?? ''}
        onChange={(event) => onChange(fromKey, event.target.value)}
        inputProps={{ min: 0, step: 'any' }}
        error={Boolean(errors[fromKey])}
        helperText={errors[fromKey] || 'Exclusive'}
      />
      <TextField
        label="To (m)"
        type="number"
        size="small"
        value={item[toKey] === 0 ? '' : item[toKey] ?? ''}
        onChange={(event) => onChange(toKey, event.target.value)}
        inputProps={{ min: 0, step: 'any' }}
        error={Boolean(errors[toKey])}
        helperText={errors[toKey] || 'Inclusive; empty = no upper limit'}
      />
      <Box sx={{ height: 40, display: 'flex', alignItems: 'center' }}>
        <ColorList label={`${label} color`} value={item[colorKey]} onChange={(value) => onChange(colorKey, value)} customPicker />
      </Box>
    </Box>
  );
}

export default function DailyStatsSettings({ item, onChange, errors = {} }) {
  return (
    <Box>
      <FormControlLabel
        label="Use custom daily-stat colors"
        control={<Checkbox checked={item.dailyStatsCustomColors} onChange={(event) => onChange('dailyStatsCustomColors', event.target.checked)} />}
      />
      <Typography variant="body2" sx={{ mb: 2 }}>
        Colors apply to the zinc crown. Disable custom colors to use the original colors and ranges.
      </Typography>
      {dailyStatsRangeFields.map((row, index) => (
        <ColorRangeRow key={row.fromKey} {...row} item={item} onChange={onChange} errors={errors} label={`Range ${index + 1}`} />
      ))}
      <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        <ColorField label="Base color (outside the ranges)" value={item.dailyStatsBaseColor} onChange={(value) => onChange('dailyStatsBaseColor', value)} />
        <ColorField label="New daily record" value={item.dailyStatsRecordColor} onChange={(value) => onChange('dailyStatsRecordColor', value)} />
      </Box>
    </Box>
  );
}
